import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import type { ContentTable } from 'pdfmake/interfaces';
import type { GetStandardFormFieldLabel } from 'src/hooks/forms/useFormCustomisation';
import { useLazyGetDocumentOversightResultsByDocumentId } from 'src/hooks/queries';

import { toLocalDate } from '@/utils/dateUtils';
import { createTable, tableHeaders } from '@/utils/pdf/table';

const useOversightPerformanceExportTable = (
  documentId: string,
  getStandardFieldLabel: GetStandardFormFieldLabel
): [() => Promise<ContentTable>, boolean] => {
  const { getLabel: getAssessmentStatusLabel } = useRating('assessment_status');
  const { getLabel: getPerformanceResultLabel } =
    useRating('performance_result');

  const [getDocumentAssessmentsResults, getDocumentAssessmentsResultsResult] =
    useLazyGetDocumentOversightResultsByDocumentId();

  const createExportTable = async () => {
    const { data: assessmentData } = await getDocumentAssessmentsResults({
      documentId,
    });
    const assessmentsTableData = (
      assessmentData?.document_oversight_result ?? []
    ).map((au) => [
      au.parents?.filter((p) => p.oversightAssessment)[0]?.oversightAssessment
        ?.Title ?? '-',
      getAssessmentStatusLabel(
        au.parents?.filter((p) => p.oversightAssessment)[0]?.oversightAssessment
          ?.Status ?? '-'
      ),
      getPerformanceResultLabel(au.Rating),
      toLocalDate(
        au.parents?.filter((p) => p.oversightAssessment)[0]?.oversightAssessment
          ?.StartDate
      ),
      toLocalDate(
        au.parents?.filter((p) => p.oversightAssessment)[0]?.oversightAssessment
          ?.ActualCompletionDate
      ),
      au.parents?.filter((p) => p.oversightAssessment)[0]?.oversightAssessment
        ?.completedByUser?.FriendlyName ?? '-',
    ]);

    return createTable({
      widths: '*',
      body: [
        tableHeaders([
          getStandardFieldLabel('oversight_assessment', 'Title'),
          getStandardFieldLabel('oversight_assessment', 'Status'),
          getStandardFieldLabel('document_oversight_result', 'Rating'),
          getStandardFieldLabel('oversight_assessment', 'StartDate'),
          getStandardFieldLabel('oversight_assessment', 'ActualCompletionDate'),
          getStandardFieldLabel('oversight_assessment', 'CompletedByUser'),
        ]),
        ...assessmentsTableData,
      ],
    });
  };

  return [createExportTable, getDocumentAssessmentsResultsResult.loading];
};

export default useOversightPerformanceExportTable;
